import React from 'react';
import { NavLink } from 'react-router-dom';
import { PrimaryButton } from '../../../../shared/ui/Inputs';

export const OrdersActionBar: React.FC = () => {
  return (
    <NavLink to="/order/newOrder">
      <PrimaryButton
        style={{
          width: '150px',
          paddingTop: '10px',
          paddingBottom: '10px',
          fontSize: '15px',
          height: 'auto',
        }}
      >
        Novo pedido
      </PrimaryButton>
    </NavLink>
  );
};
